import React from 'react';
import ModernCTA from '../../components/ModernCTA';

const EcommerceServices = () => {
  return (
    <div className="ecommerce-services-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <span className="eyebrow">E-COMMERCE SOLUTIONS</span>
            <h1>
              <span className="gradient-text">Headless Commerce</span> Platforms
            </h1>
            <p className="subtitle">
              Shopify Plus, BigCommerce, and custom PWA implementations that outperform traditional platforms
            </p>
          </div>
        </div>
      </section>

      {/* Platforms Section */}
      <section className="platforms-section">
        <div className="container">
          <div className="section-header">
            <span className="eyebrow">TECHNOLOGY</span>
            <h2>Platforms We <span className="highlight">Specialize In</span></h2>
          </div>
          
          <div className="platforms-grid">
            <div className="platform-card">
              <div className="platform-header">
                <div className="platform-icon shopify">S+</div>
                <h3>Shopify Plus</h3>
              </div>
              <ul className="platform-features">
                <li>Headless storefronts</li>
                <li>Custom checkout extensions</li>
                <li>High-volume optimization</li>
                <li>App integrations</li>
              </ul>
            </div>

            <div className="platform-card">
              <div className="platform-header">
                <div className="platform-icon bigcommerce">BC</div>
                <h3>BigCommerce</h3>
              </div>
              <ul className="platform-features">
                <li>B2B/B2C solutions</li>
                <li>Multi-storefront</li>
                <li>API-first architecture</li>
                <li>Enterprise scalability</li>
              </ul>
            </div>

            <div className="platform-card">
              <div className="platform-header">
                <div className="platform-icon custom">PWA</div>
                <h3>Custom PWA</h3>
              </div>
              <ul className="platform-features">
                <li>Progressive Web Apps</li>
                <li>Mobile-first experiences</li>
                <li>Offline capabilities</li>
                <li>Blazing fast performance</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="container">
          <div className="section-header">
            <span className="eyebrow">ADVANTAGES</span>
            <h2>Why Choose <span className="highlight">Headless</span> Commerce?</h2>
          </div>

          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon">⚡</div>
              <h3>Lightning Fast</h3>
              <p>3x faster load times with decoupled frontends</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icon">🎨</div>
              <h3>Design Freedom</h3>
              <p>Complete creative control over your storefront</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icon">📱</div>
              <h3>Omnichannel</h3>
              <p>Deploy anywhere with a single backend</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icon">🔄</div>
              <h3>Future Proof</h3>
              <p>Easily adapt to new technologies</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icon">🔌</div>
              <h3>Easy Integrations</h3>
              <p>Connect any third-party service via API</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icon">📈</div>
              <h3>Higher Conversions</h3>
              <p>Optimized experiences outperform traditional stores</p>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="process-section">
        <div className="container">
          <div className="section-header">
            <span className="eyebrow">METHODOLOGY</span>
            <h2>Our <span className="highlight">Implementation</span> Process</h2>
          </div>

          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Discovery & Strategy</h3>
                <p>Analyze business requirements and customer journeys</p>
              </div>
            </div>
            
            <div className="process-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Platform Selection</h3>
                <p>Recommend ideal commerce platform for your needs</p>
              </div>
            </div>
            
            <div className="process-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>UX/UI Design</h3>
                <p>Create conversion-optimized designs</p>
              </div>
            </div>
            
            <div className="process-step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Headless Development</h3>
                <p>Build custom frontend connected via API</p>
              </div>
            </div>
            
            <div className="process-step">
              <div className="step-number">5</div>
              <div className="step-content">
                <h3>Performance Tuning</h3>
                <p>Optimize every aspect for maximum speed</p>
              </div>
            </div>
            
            <div className="process-step">
              <div className="step-number">6</div>
              <div className="step-content">
                <h3>Launch & Growth</h3>
                <p>Deploy and provide ongoing optimization</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ModernCTA />

      {/* Styles */}
      <style jsx>{`
        .ecommerce-services-page {
          margin-top: 80px;
          color: #f8fafc;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          line-height: 1.6;
          background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
        }
        
        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }
        
        /* Typography */
        .eyebrow {
          display: block;
          font-size: 0.875rem;
          font-weight: 600;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: #818cf8;
          margin-bottom: 1rem;
        }
        
        h1, h2, h3 {
          font-weight: 800;
          line-height: 1.2;
          margin-bottom: 1.5rem;
        }
        
        h1 {
          font-size: 2.5rem;
        }
        
        h2 {
          font-size: 2rem;
        }
        
        h3 {
          font-size: 1.25rem;
        }
        
        .highlight {
          color: #818cf8;
        }
        
        .gradient-text {
          background: linear-gradient(90deg, #6366f1 0%, #8b5cf6 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        
        p {
          color: #94a3b8;
          font-size: 1rem;
        }
        
        /* Hero Section */
        .hero-section {
          padding: 60px 0;
          text-align: center;
        }
        
        .hero-content {
          max-width: 800px;
          margin: 0 auto;
        }
        
        .subtitle {
          font-size: 1.1rem;
          max-width: 600px;
          margin: 0 auto;
        }
        
        /* Platforms Section */
        .platforms-section {
          padding: 60px 0;
          background: rgba(15, 23, 42, 0.5);
        }
        
        .section-header {
          text-align: center;
          margin-bottom: 40px;
        }
        
        .platforms-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 20px;
        }
        
        .platform-card {
          background: rgba(30, 41, 59, 0.7);
          border-radius: 12px;
          padding: 25px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          transition: transform 0.3s ease;
        }
        
        .platform-card:hover {
          transform: translateY(-5px);
        }
        
        .platform-header {
          display: flex;
          align-items: center;
          gap: 15px;
          margin-bottom: 20px;
        }
        
        .platform-icon {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 1rem;
          flex-shrink: 0;
        }
        
        .platform-icon.shopify {
          background: rgba(150, 191, 72, 0.1);
          color: #96bf48;
          border: 1px solid rgba(150, 191, 72, 0.3);
        }
        
        .platform-icon.bigcommerce {
          background: rgba(18, 24, 64, 0.1);
          color: #818cf8;
          border: 1px solid rgba(18, 24, 64, 0.3);
        }
        
        .platform-icon.custom {
          background: rgba(99, 102, 241, 0.1);
          color: #6366f1;
          border: 1px solid rgba(99, 102, 241, 0.3);
        }
        
        .platform-features {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        
        .platform-features li {
          position: relative;
          padding-left: 25px;
          margin-bottom: 10px;
          color: #cbd5e1;
          font-size: 0.95rem;
        }
        
        .platform-features li::before {
          content: '•';
          color: #818cf8;
          position: absolute;
          left: 0;
          font-size: 1.2rem;
        }
        
        /* Benefits Section */
        .benefits-section {
          padding: 60px 0;
        }
        
        .benefits-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 20px;
        }
        
        .benefit-card {
          background: rgba(30, 41, 59, 0.5);
          border-radius: 12px;
          padding: 25px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          text-align: center;
        }
        
        .benefit-icon {
          font-size: 1.75rem;
          margin-bottom: 15px;
          display: inline-block;
        }
        
        .benefit-card h3 {
          margin-bottom: 10px;
          font-size: 1.2rem;
        }
        
        .benefit-card p {
          margin: 0;
          font-size: 0.95rem;
        }
        
        /* Process Section */
        .process-section {
          padding: 60px 0;
          background: rgba(15, 23, 42, 0.5);
        }
        
        .process-steps {
          display: grid;
          grid-template-columns: 1fr;
          gap: 20px;
        }
        
        .process-step {
          display: flex;
          gap: 15px;
          background: rgba(30, 41, 59, 0.7);
          border-radius: 12px;
          padding: 20px;
          border: 1px solid rgba(255, 255, 255, 0.1);
        }
        
        .step-number {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.25rem;
          font-weight: 700;
          color: white;
          flex-shrink: 0;
        }
        
        .step-content h3 {
          margin-bottom: 8px;
          font-size: 1.2rem;
        }
        
        .step-content p {
          font-size: 0.95rem;
        }
        
        /* Tablet and Desktop Styles */
        @media (min-width: 640px) {
          .ecommerce-services-page {
            margin-top: 115px;
          }
          
          h1 {
            font-size: 2.75rem;
          }
          
          h2 {
            font-size: 2.25rem;
          }
          
          h3 {
            font-size: 1.5rem;
          }
          
          .hero-section {
            padding: 80px 0;
          }
          
          .platforms-section, .benefits-section, .process-section {
            padding: 80px 0;
          }
          
          .platforms-grid, .benefits-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        
        @media (min-width: 768px) {
          h1 {
            font-size: 3rem;
          }
          
          .platforms-grid, .benefits-grid {
            grid-template-columns: repeat(3, 1fr);
          }
          
          .process-steps {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        
        @media (min-width: 1024px) {
          .process-steps {
            grid-template-columns: repeat(3, 1fr);
          }
        }
      `}</style>
    </div>
  );
};

export default EcommerceServices;